import React, {
  createContext,
  useState,
  useContext,
  useMemo,
  useEffect
} from 'react'
import { useParams } from 'react-router-dom'
import { DisputeDTO } from '../dtos'
import { useDispute } from '../useDet'

const TIME_TO_REFETCH_DISPUTE = 5000

interface IDisputeContext {
  disputeId?: string
  isDisputeLoading: boolean
  setDispute: (dispute: DisputeDTO) => void
  dispute: DisputeDTO
}

const DisputeContext = createContext<IDisputeContext>({})

export const DisputeProvider = ({ children }) => {
  const { id: disputeId } = useParams<{ id: string }>()
  const { disputeData, refetchDispute, isDisputeLoading } =
    useDispute(disputeId)
  const [dispute, setDispute] = useState(null)
  const [timeoutId, setTimeoutId] = useState(null)

  useEffect(() => {
    setDispute(disputeData)
  }, [setDispute, disputeData])

  useEffect(() => {
    if (dispute?.lifecycleTransitioningTo) {
      if (!timeoutId) {
        // Schedule only 1 timeout at a time
        const refetchTimeoutId = setTimeout(() => {
          setTimeoutId(null)
          refetchDispute()
        }, TIME_TO_REFETCH_DISPUTE)
        setTimeoutId(refetchTimeoutId)
      }
    }
  }, [dispute])

  const contextValue = useMemo(
    () => ({
      disputeId,
      dispute,
      setDispute,
      isDisputeLoading
    }),
    [disputeId, dispute, setDispute, isDisputeLoading]
  )

  return (
    <DisputeContext.Provider value={contextValue}>
      {children}
    </DisputeContext.Provider>
  )
}

export const useDisputeContext = () => {
  return useContext(DisputeContext)
}
